import Box from "@mui/material/Box";
import leeftMark from "../assets/img/leeft-mark.png";

/**
 * The Leeft geometric mark (docker/sftpgo/static/branding/img/leeft-logo-256.png,
 * copied to src/assets/img). It is a transparent PNG with a teal (#0A4145)
 * fill. There is no separate white asset in the repo, so the "onDark"
 * variant recolours it to white with a CSS filter instead of shipping a
 * second file. If Leeft later provides a dedicated white SVG mark
 * (docs/design/leeft-design-tokens.md section 2.2), swap it in here.
 */
export function LogoMark({
  size = 32,
  variant = "brand",
}: {
  size?: number;
  variant?: "brand" | "onDark";
}) {
  return (
    <Box
      component="img"
      src={leeftMark}
      alt="Leeft"
      sx={{
        width: size,
        height: size,
        display: "block",
        filter: variant === "onDark" ? "brightness(0) invert(1)" : "none",
      }}
    />
  );
}
